/**
 * Tawk.to Widget Positioning
 *
 * Ensures the Tawk.to chat widget is properly positioned above the audio playbar.
 */

export function initializeTawkStyles() {
  // Wait for Tawk.to to load
  const checkTawkLoaded = setInterval(() => {
    // @ts-ignore - Tawk_API is loaded by external script
    if (typeof window.Tawk_API !== 'undefined' && window.Tawk_API) {
      clearInterval(checkTawkLoaded);

      // @ts-ignore
      window.Tawk_API.onLoad = function() {
        // Apply positioning to ensure widget is above audio playbar
        applyTawkPositioning();
      };

      // Also apply immediately in case already loaded
      applyTawkPositioning();
    }
  }, 100);

  // Clear interval after 10 seconds to prevent memory leaks
  setTimeout(() => clearInterval(checkTawkLoaded), 10000);
}

function applyTawkPositioning() {
  // Target all Tawk.to iframes and containers
  const selectors = [
    'iframe[title*="chat" i]',
    'iframe[src*="tawk.to"]',
    '#tawkchat-minified-box',
    '#tawkchat-container',
    '.tawk-min-container',
    '[id^="tawk"]',
    '[class*="tawk"]'
  ];

  selectors.forEach(selector => {
    const elements = document.querySelectorAll(selector);
    elements.forEach(element => {
      if (element instanceof HTMLElement) {
        // Apply positioning only
        element.style.setProperty('bottom', '110px', 'important');
        element.style.setProperty('right', '20px', 'important');
        element.style.setProperty('z-index', '50', 'important');

        // Mobile-specific
        if (window.innerWidth <= 768) {
          element.style.setProperty('bottom', '100px', 'important');
          element.style.setProperty('right', '16px', 'important');
        }
      }
    });
  });
}

// Re-apply positioning on window resize (for mobile/desktop transitions)
let resizeTimeout: NodeJS.Timeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    applyTawkPositioning();
  }, 250);
});

// Observe DOM changes to catch dynamically added Tawk.to elements
const observer = new MutationObserver(() => {
  applyTawkPositioning();
});

// Start observing when DOM is ready
if (document.body) {
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
} else {
  window.addEventListener('DOMContentLoaded', () => {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}
